import * as Redux from 'redux';
import { resultsModel } from './results-model';
import { pageModel } from './page-model';
import { searchTermModel } from './search-term-model';
import { categoriesModel } from './categories-model';
import { ISearchResult, IResults } from '../state-helpers/search-results';
import { ICategories } from '../state-helpers/categories';
import { ISearchCriteria } from '../state-helpers/search-criteria';
import { IPage } from '../state-helpers/page';
import { browserNavigated } from './browser-navigated';

export interface IState {
    resultsModel: IResults;
    categoriesModel: ICategories;
    pageModel: IPage;
    dispatch: Redux.Dispatch<IState>;
    searchTermModel: string;
    browserNavigated: boolean;
}


export const rootReducer = Redux.combineReducers({
    resultsModel,
    searchTermModel,
    pageModel,
    browserNavigated,
    categoriesModel
});